import {Spinner} from '@primer/react'

export const SkeletonLoaderOverview = () => (
  <div className="Box position-relative">
    <div className="Box-header">
      <h3 className="Box-title">Overview</h3>
    </div>
    <div className="Box-row p-0">
      <div className="d-flex flex-wrap flex-items-center flex-justify-center" style={{height: 162}}>
        <Spinner />
      </div>
    </div>
  </div>
)
